import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/img/coupon_icon.svg'


const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "text-header mb-0" }, "Valores personalizados", -1)
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "fa-2x fas fa-folder-open text-muted mb-2" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "text-paragraph" }, "Nenhum código criado", -1)
const _hoisted_8 = { class: "card-body" }
const _hoisted_9 = { class: "d-flex align-items-center" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_11 = { class: "text-subtitle mb-0 ms-2" }
const _hoisted_12 = {
  class: "border border-primary border-2 rounded p-3 d-flex my-3",
  style: {"border-style":"dashed !important"}
}
const _hoisted_13 = { class: "text-header mb-0" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = {
  key: 0,
  class: "text-label text-danger mb-0"
}
const _hoisted_16 = {
  key: 1,
  class: "text-label text-muted mb-0"
}
const _hoisted_17 = ["onClick"]
const _hoisted_18 = {
  key: 0,
  class: "text-label text-primary50 me-2 mb-0"
}
const _hoisted_19 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-trash-alt text-muted" }, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("p", { class: "text-subtitle mb-0 ms-2 text-muted" }, "Remover", -1)
const _hoisted_23 = [
  _hoisted_21,
  _hoisted_22
]
const _hoisted_24 = {
  key: 0,
  class: "text-paragraph"
}
const _hoisted_25 = /*#__PURE__*/_createStaticVNode("<div class=\"card cursor-pointer\"><div class=\"card-body\"><div class=\"d-flex align-items-center\"><div class=\"d-flex align-items-center\"><img src=\"" + _imports_0 + "\" alt=\"\"><p class=\"text-subtitle mb-0 ms-2\">Criar novo código</p></div><i class=\"fa-solid fa-chevron-right text-primary ms-auto\"></i></div></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingContainer = _resolveComponent("LoadingContainer")!
  const _component_EmptyState = _resolveComponent("EmptyState")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("p", {
        class: "text-subtitle mb-0 text-secondary cursor-pointer",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleAddCoupon && _ctx.handleAddCoupon(...args)))
      }, " Criar novo código ")
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_ctx.loadingItems)
        ? (_openBlock(), _createBlock(_component_LoadingContainer, { key: 0 }))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (!_ctx.items.length)
              ? (_openBlock(), _createBlock(_component_EmptyState, {
                  key: 0,
                  totalItemsRegistered: _ctx.totalItemsRegistered
                }, {
                  noItemsRegistered: _withCtx(() => [
                    _hoisted_6,
                    _hoisted_7
                  ]),
                  _: 1
                }, 8, ["totalItemsRegistered"]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "card"
              }, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _hoisted_10,
                    _createElementVNode("p", _hoisted_11, _toDisplayString(item.percent_off_label), 1)
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", null, [
                      _createElementVNode("p", _hoisted_13, _toDisplayString(item.code), 1),
                      (item.redeem_by)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                            (item.is_expired)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_15, " Expirado "))
                              : (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(item.redeem_by_label), 1))
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    (!item.is_expired)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "d-flex align-items-center ms-auto cursor-pointer",
                          onClick: ($event: any) => (_ctx.handleCopyCoupon(item))
                        }, [
                          (_ctx.copied && _ctx.currentItem == item.id)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_18, " Copiado "))
                            : _createCommentVNode("", true),
                          _createElementVNode("i", {
                            class: _normalizeClass(["fa-solid fa-copy display-5", {
                    'text-primary50': _ctx.copied && _ctx.currentItem == item.id,
                    'text-primary': !_ctx.copied || _ctx.currentItem !== item.id,
                  }])
                          }, null, 2)
                        ], 8, _hoisted_17))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", {
                      class: "d-flex align-items-center cursor-pointer",
                      onClick: ($event: any) => (_ctx.handleDeleteCoupon(item))
                    }, _hoisted_23, 8, _hoisted_20),
                    (item.max_redemptions_customers)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_24, _toDisplayString(item.max_redemptions_customers_label), 1))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
            }), 128)),
            _hoisted_25
          ]))
    ])
  ]))
}